// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"e144353e","865":"8c82ea0e"}[chunkId] + ".chunk.js";
};